import { render, staticRenderFns } from "./teacher-ask.vue?vue&type=template&id=26c941ed&"
import script from "./teacher-ask.vue?vue&type=script&lang=js&"
export * from "./teacher-ask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports